import { useEffect, useState } from 'react';
import api from '@/lib/api';

interface Shipment {
  id: string;
  orderNumber: string;
  carrier: string;
  trackingCode: string;
  status: string;
  dispatchedAt: string | null;
  deliveredAt: string | null;
}

const shipmentStatusLabels: Record<string, { label: string; color: string }> = {
  PENDING: { label: 'Pendente', color: 'bg-gray-100 text-gray-700' },
  DISPATCHED: { label: 'Despachado', color: 'bg-blue-100 text-blue-700' },
  IN_TRANSIT: { label: 'Em Trânsito', color: 'bg-yellow-100 text-yellow-700' },
  DELIVERED: { label: 'Entregue', color: 'bg-green-100 text-green-700' },
  RETURNED: { label: 'Devolvido', color: 'bg-red-100 text-red-700' },
};

export default function ShippingPage() {
  const [shipments, setShipments] = useState<Shipment[]>([]);
  const [loadingData, setLoadingData] = useState(true);

  useEffect(() => {
    api.get('/shipping').then((r) => {
      setShipments(r.data.data || r.data);
      setLoadingData(false);
    });
  }, []);

  const handleDispatch = async (id: string) => {
    await api.patch(`/shipping/${id}/dispatch`);
    api.get('/shipping').then((r) => setShipments(r.data.data || r.data));
  };

  return loadingData ? (
        <div className="flex items-center justify-center h-64">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary-600"></div>
        </div>
      ) : (
        <div className="bg-white rounded-xl shadow-sm border border-dark-100 overflow-hidden">
          <table className="w-full">
            <thead className="bg-dark-50">
              <tr>
                <th className="px-6 py-3 text-left text-xs font-medium text-dark-500 uppercase">Pedido</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-dark-500 uppercase">Transportadora</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-dark-500 uppercase">Código Rastreio</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-dark-500 uppercase">Status</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-dark-500 uppercase">Despacho</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-dark-500 uppercase">Entrega</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-dark-500 uppercase">Ação</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-dark-100">
              {shipments.map((shipment, index) => (
                <tr key={shipment.id} className={index % 2 === 0 ? 'bg-white' : 'bg-dark-50/50'}>
                  <td className="px-6 py-4 text-sm font-medium text-primary-600">{shipment.orderNumber}</td>
                  <td className="px-6 py-4 text-sm text-dark-600">{shipment.carrier || '-'}</td>
                  <td className="px-6 py-4 text-sm text-dark-600">{shipment.trackingCode || '-'}</td>
                  <td className="px-6 py-4">
                    <span className={`px-2.5 py-1 text-xs font-medium rounded-full ${shipmentStatusLabels[shipment.status]?.color || 'bg-gray-100 text-gray-700'}`}>
                      {shipmentStatusLabels[shipment.status]?.label || shipment.status}
                    </span>
                  </td>
                  <td className="px-6 py-4 text-sm text-dark-500">
                    {shipment.dispatchedAt ? new Date(shipment.dispatchedAt).toLocaleDateString('pt-BR') : '-'}
                  </td>
                  <td className="px-6 py-4 text-sm text-dark-500">
                    {shipment.deliveredAt ? new Date(shipment.deliveredAt).toLocaleDateString('pt-BR') : '-'}
                  </td>
                  <td className="px-6 py-4">
                    {shipment.status === 'PENDING' && (
                      <button
                        onClick={() => handleDispatch(shipment.id)}
                        className="px-3 py-1.5 bg-primary-600 text-white rounded-lg text-xs font-medium hover:bg-primary-700 transition-colors"
                      >
                        Despachar
                      </button>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          {shipments.length === 0 && (
            <div className="text-center py-12 text-dark-500">Nenhuma expedição encontrada</div>
          )}
        </div>
  );
}
